import {
	SidebarGroup,
	SidebarGroupContent,
	SidebarMenu,
	SidebarMenuButton,
	SidebarMenuItem,
} from "@shared/ui/sidebar";
import { Link } from "@tanstack/react-router";
import { HelpCircle, Users } from "lucide-react";
import { defineMessages, useIntl } from "react-intl";

const messages = defineMessages({
	users: {
		id: "page.users.title",
		defaultMessage: "Users",
	},
	help: {
		id: "page.help.title",
		defaultMessage: "Get Help",
	},
});

const navItems = [
	{
		message: messages.users,
		url: "/users",
		icon: Users,
	},
	{
		message: messages.help,
		url: "/help",
		icon: HelpCircle,
	},
];

export function NavSecondary() {
	const intl = useIntl();

	return (
		<SidebarGroup className="mt-auto">
			<SidebarGroupContent className="flex flex-col gap-4">
				<SidebarMenu className="space-y-2">
					{navItems.map((item) => (
						<SidebarMenuItem key={item.message.id}>
							<Link to={item.url}>
								{({ isActive }) => (
									<SidebarMenuButton
										tooltip={intl.formatMessage(item.message)}
										className="cursor-pointer"
										isActive={isActive}
									>
										{item.icon && <item.icon />}
										<span>{intl.formatMessage(item.message)}</span>
									</SidebarMenuButton>
								)}
							</Link>
						</SidebarMenuItem>
					))}
				</SidebarMenu>
			</SidebarGroupContent>
		</SidebarGroup>
	);
}
